export enum BeErrorCode {
  API_KEY_INVALID = 'API_KEY_INVALID',
  API_KEY_MISSING = 'API_KEY_MISSING',
  JWT_TOKEN_EXPIRED = 'JWT_TOKEN_EXPIRED',
  JWT_TOKEN_INVALID = 'JWT_TOKEN_INVALID',
  SF_OAUTH_EXPIRED = 'SF_OAUTH_EXPIRED',
  SF_OAUTH_INVALID = 'SF_OAUTH_INVALID',
  SF_OAUTH_UNUSABLE = 'SF_OAUTH_UNUSABLE',
}

export enum BeErrorCodeUnusableOrgCredential {
  SF_OAUTH_EXPIRED = BeErrorCode.SF_OAUTH_EXPIRED,
  SF_OAUTH_INVALID = BeErrorCode.SF_OAUTH_INVALID,
  SF_OAUTH_UNUSABLE = BeErrorCode.SF_OAUTH_UNUSABLE,
}
